import React, { useState } from "react";
import { FV } from "@/components/Form/Validation/FormValidators";
import i18n from "@/i18n";
import BFInput from "@/modules/abstract-ui/forms/input/BFInput";
import classNames from "classnames";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import BFSelect from "@/modules/abstract-ui/forms/select/BFSelect";

type Props = {
  setCurrentFieldEditing: (fieldName: string) => void;
};

const VacancyContractFormTenantPart = (props: Props) => {
  const { setCurrentFieldEditing } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const ARRAY_FIELD_NAME = "tenants";

  return (
    <div className="applicant-form-part form-section">
      <div className="__h3">
        {i18n.t(
          "apTemplate:Vacancy.Applicant.Contract.Label.ApplicantTitle",
          "Vertragspartner (Mieter)"
        )}
      </div>
      <FieldArray name={ARRAY_FIELD_NAME}>
        {({ fields }) => {
          return (
            <div>
              {fields.length > 0 && (
                <>
                  <BFSelect
                    value={selectedIndex}
                    onChange={(e) => {
                      setSelectedIndex(Number(e));
                    }}
                    data={fields.map((_name, index) => {
                      return {
                        label: `${i18n.t(
                          "apTemplate:Vacancy.Applicant.Contract.Label.Applicant",
                          "Vertragspartner"
                        )} ${index + 1}`,
                        value: index,
                      };
                    })}
                  />
                  <ContractPersonFields
                    fieldPrefix={`${ARRAY_FIELD_NAME}[${selectedIndex}]`}
                    setCurrentFieldEditing={setCurrentFieldEditing}
                  />
                </>
              )}
            </div>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default VacancyContractFormTenantPart;

type ContractPersonFieldsProps = {
  fieldPrefix: string;
  setCurrentFieldEditing: (fieldName: string) => void;
};

const ContractPersonFields = (props: ContractPersonFieldsProps) => {
  const { fieldPrefix, setCurrentFieldEditing } = props;

  return (
    <>
      <div className={classNames("__flex-row __justify-between")}>
        <Field name={`${fieldPrefix}.firstName`}>
          {({ input, meta }) => {
            return (
              <div className="__field">
                <BFInput
                  label={i18n.t(
                    "apTemplate:Vacancy.Applicant.Contract.Label.FirstName",
                    "Vorname"
                  )}
                  {...input}
                  {...FV.getValidation(meta)}
                  onFocus={() => {
                    input.onFocus();
                  }}
                  onChange={(e) => {
                    setCurrentFieldEditing(input.name);
                    input.onChange(e);
                  }}
                />
              </div>
            );
          }}
        </Field>
        <Field name={`${fieldPrefix}.lastName`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.LastName",
                  "Nachname"
                )}
                {...input}
                {...FV.getValidation(meta)}
                onFocus={() => {
                  setCurrentFieldEditing(input.name);
                  input.onFocus();
                }}
              />
            </div>
          )}
        </Field>
      </div>
      <div className={classNames("__flex-row __justify-between")}>
        <Field name={`${fieldPrefix}.street`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.Street",
                  "Straße"
                )}
                {...input}
                {...FV.getValidation(meta)}
                onFocus={() => {
                  setCurrentFieldEditing(input.name);
                  input.onFocus();
                }}
              />
            </div>
          )}
        </Field>
        <Field name={`${fieldPrefix}.streetNumber`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.StreetNumber",
                  "Hausnummer"
                )}
                type="number"
                {...input}
                {...FV.getValidation(meta)}
                onFocus={() => {
                  setCurrentFieldEditing(input.name);
                  input.onFocus();
                }}
              />
            </div>
          )}
        </Field>
      </div>
      <div className={classNames("__flex-row __justify-between")}>
        <Field name={`${fieldPrefix}.zipCode`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.Zip",
                  "Postleitzahl"
                )}
                {...input}
                {...FV.getValidation(meta)}
                onFocus={() => {
                  setCurrentFieldEditing(input.name);
                  input.onFocus();
                }}
              />
            </div>
          )}
        </Field>
        <Field name={`${fieldPrefix}.city`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.City",
                  "Stadt"
                )}
                {...input}
                {...FV.getValidation(meta)}
                onFocus={() => {
                  setCurrentFieldEditing(input.name);
                  input.onFocus();
                }}
              />
            </div>
          )}
        </Field>
      </div>
      <div className={classNames("__flex-row __justify-between")}>
        <Field name={`${fieldPrefix}.email`}>
          {({ input, meta }) => (
            <div className="__field">
              <BFInput
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Contract.Label.Mail",
                  "E-Mail"
                )}
                {...input}
                {...FV.getValidation(meta)}
              />
            </div>
          )}
        </Field>
      </div>
    </>
  );
};
